import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseContentSeoDto
*  SEO-атрибуты (для web-каналов; fallback-приоритеты применяет витрина)<br>
*/
export class ShowcaseContentSeoDto extends ActiveModel {

/**
  * metaTitle
  * SEO: заголовок страницы (meta title). <br><br>Если не задан — витрина генерирует его из Domain.Entities.Content.ContentItem.Title
  */
  @ActiveField()
  metaTitle?: null | string


/**
  * metaDescription
  * SEO: описание страницы (meta description). <br><br>Если не задано — витрина генерирует его из Domain.Entities.Content.ContentItem.Announce
  */
  @ActiveField()
  metaDescription?: null | string


/**
  * ogImageId
  * SEO: og-картинка страницы. Domain.Entities.Resources.Resource.Id<br><br>Если не задана — витрина берёт обложку Domain.Entities.Content.ContentItem.Cover,<br>затем дефолтную og-картинку витрины<br>
  */
  @ActiveField()
  ogImageId?: null | string


/**
  * canonicalUrl
  * Переопределение canonical-URL; null — витрина строит canonical сама<br>
  */
  @ActiveField()
  canonicalUrl?: null | string


  /**
  * noIndex
  * Закрыть страницу от индексации (robots noindex); канальная политика<br>RobotsPolicy.NoindexAll действует поверх<br>  */
  @ActiveField(false)
  noIndex: boolean = false
}
